import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../../../reusableComponents/tables/Table/table';
import Card from '../../../reusableComponents/cards/Card71';
import Button from '../../../reusableComponents/buttons/button22';
import VideoPlayer from './materialType/Video';
import StudyMaterialsBadge from '../../../reusableComponents/badges/studyMaterialBadges/StudyMaterialBadges';

const ActionsButton = ({ onClick }) => {
  return (
    <Button text="View" onClick={onClick} />
  );
};

// Empty state component when no materials are available
const EmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="text-gray-400">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      </div>
      <h3 className="text-2xl font-semibold text-neutral-900 mb-2">All Caught Up!</h3>
      <p className="text-center text-neutral-600 max-w-md">
        You don't have any study materials assigned at the moment. 
        Check back later or contact your instructor.
      </p>
    </div>
  );
};

const StudyTable = () => {
  const [filterType, setFilterType] = useState('');
  const navigate = useNavigate();

  const headers = ['ID', 'Study Material name', 'Tutor name', 'Date updated', 'Material type', 'Actions'];

  // Study materials data with video URLs
  const studyMaterials = [
    // {
    //   id: 1,
    //   name: 'Introduction to React',
    //   tutor: 'John Doe',
    //   dateUpdated: '2023-10-01',
    //   type: 'PDF',
    //   url: 'https://example.com/pdf-file.pdf'
    // },
    // {
    //   id: 2,
    //   name: 'JavaScript Fundamentals',
    //   tutor: 'Jane Smith',
    //   dateUpdated: '2023-10-02',
    //   type: 'Video',
    //   url: '',
    //   description: 'A comprehensive tutorial on JavaScript basics for beginners.'
    // },
    // {
    //   id: 3,
    //   name: 'Web Development Podcast',
    //   tutor: 'Alice Johnson',
    //   dateUpdated: '2023-10-03',
    //   type: 'Audio',
    //   url: 'https://example.com/audio-file.mp3'
    // },
    // {
    //   id: 4,
    //   name: 'CSS Layout Patterns',
    //   tutor: 'Bob Brown',
    //   dateUpdated: '2023-10-04',
    //   type: 'Text Book',
    //   url: 'https://example.com/textbook.pdf'
    // }
  ];

  // Check if there are any study materials
  const hasMaterials = studyMaterials.length > 0;

  // Prepare table data from study materials
  const tableData = studyMaterials.map(material => ({
    id: material.id,
    contents: [
      `SM${material.id}`,
      material.name,
      material.tutor,
      material.dateUpdated,
      material.type,
      ''
    ],
    swappableComponents: [
      null,
      null,
      null,
      null,
      <StudyMaterialsBadge type={material.type} />,
      <ActionsButton onClick={() => handleViewMaterial(material)} />
    ],
    swappedIndices: [4, 5],
    isExpandable: false,
    hasCheckbox: false
  }));

  // Handler for View button actions
  const handleViewMaterial = (material) => {
    console.log(`Viewing material with ID: ${material.id}`);

    if (material.type === 'Video') {
      // Navigate to video player page with study material data
      navigate(`/learning/materials/material?id=${material.id}&type=video`, {
        state: {
          videoData: {
            videoUrl: material.url,
            title: material.name,
            description: material.description || `Video material by ${material.tutor}`
          },
          materialName: material.name
        }
      });
    }
    // Add handlers for other material types as needed
  };

  // Filter function for filtering rows by material type
  const filterByMaterialType = (row) => {
    if (!filterType) return true;
    return row.contents[4] === filterType;
  };

  // Function to handle filter change
  const handleFilterChange = (type) => {
    setFilterType(type);
  };

  return (
    <div className="">
      {hasMaterials ? (
        <>
          <div className="flex items-center gap-4">
            {/* Filter buttons (commented out) */}
          </div>

          <Table
            headers={headers}
            data={tableData}
            onRowExpandToggle={(id, isExpanded) => console.log(`Row ${id} expanded: ${isExpanded}`)}
            onRowCheckToggle={(id, isChecked) => console.log(`Row ${id} checked: ${isChecked}`)}
            onHeaderCheckToggle={(isChecked) => console.log(`Header checked: ${isChecked}`)}
            size="XL"
            className="w-full"
            filterByColumn={filterByMaterialType}
          />
        </>
      ) : (
        <EmptyState />
      )}
    </div>
  );
};

const AllStudyMaterials = () => {
  return (
    <div>
      <Card
        title="All Study Materials"
        showTitle={true}
        showPrimaryButton={false}
        showSecondaryButton={false}
        showMenuButton={false}
        showSwapComponent1={true}
        showSwapComponent2={false}
        showSwapComponent3={false}
        showDescription={false}
        primaryButtonComponent={null}
        secondaryButtonText="Button"
        description="Optional description can be added here"
        // Custom content props
        swapContent1={<StudyTable />}
        swapContent2={null}
        swapContent3={null}
        swapLabel1="Swap component 1"
        swapLabel2="Swap component 2"
        swapLabel3="Swap component 3"
        width="w-full"
        className="shadow-md"
      />
    </div>
  );
};

export default AllStudyMaterials;